import styled from "styled-components"

export const TableContainer = styled.div`
  height: 100%;
  width: 100%;
  overflow-Y: auto;

  .ag-header-group-cell-label, .ag-header-cell-label {
    justify-content: ${({headCellJustifyContent}) => headCellJustifyContent};
  }

  .ag-header-cell-text {
    color: ${({headColor}) => headColor};
    font-size: ${({headFontSize}) => headFontSize};
    text-transform: ${({headUppercase}) => headUppercase && "uppercase"};
  }

  /* Fond du header appliqué en direct (la variable --ag-header-background-color n'est pas
     honorée par le thème AG Grid courant) — garantit un header coloré et lisible. */
  ${({ headBackgroundColor }) =>
    headBackgroundColor &&
    `.ag-header, .ag-header-cell, .ag-header-group-cell { background-color: ${headBackgroundColor}; }`}
  
  .ag-cell {
    text-align: ${({bodyTableAlignement}) => bodyTableAlignement};
  }
  
  --ag-header-background-color: ${({headBackgroundColor}) => headBackgroundColor};
  --ag-background-color: ${({bodyEvenRowBackgroundColor}) => bodyEvenRowBackgroundColor};
  --ag-odd-row-background-color: ${({bodyOddRowBackgroundColor}) => bodyOddRowBackgroundColor};
`